export default __webpack_public_path__ + "static/media/leftImg.db7e39ec.jpg";